import React, { useState } from 'react';
import {
  IonButton,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkLnrpStatus,
  lnrpLogin,
  selectLnrpError,
  selectLnrpLoading,
} from '../../store/slices/lnrp.slice';
import { AppDispatch } from '../../store/store';

interface LnrpLoginModalProps {
  isOpen: boolean;
  onDidDismiss: () => void;
}

interface LoginForm {
  username: string;
  password: string;
}

const LnrpLoginModal: React.FC<LnrpLoginModalProps> = ({
  isOpen,
  onDidDismiss,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector(selectLnrpLoading);
  const error = useSelector(selectLnrpError);
  const {
    register,
    handleSubmit,
    setError: setFormError,
    formState,
  } = useForm<LoginForm>();
  const [submitError, setSubmitError] = useState<string | null>(null);

  const onSubmit = (data: LoginForm) => {
    setSubmitError(null);
    dispatch(lnrpLogin({ username: data.username, password: data.password }))
      .unwrap()
      .then(() => {
        dispatch(checkLnrpStatus());
        onDidDismiss();
      })
      .catch((err: string) => {
        setSubmitError(err || 'Login failed');
      });
  };

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
      backdropDismiss={false}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>Sign In to Download From LNRP</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <IonList lines="none">
            <IonItem>
              <IonLabel position="stacked" style={{ zIndex: 2 }}>
                Username
              </IonLabel>
              <IonInput
                type="text"
                {...register('username', {
                  required: 'Username is required',
                })}
              />
            </IonItem>
            <IonItem>
              <IonLabel position="stacked" style={{ zIndex: 2 }}>
                Password
              </IonLabel>
              <IonInput
                type="password"
                {...register('password', {
                  required: 'Password is required',
                })}
              />
            </IonItem>
            {(submitError || error) && (
              <IonItem lines="none">
                <IonText color="danger">{submitError || error}</IonText>
              </IonItem>
            )}
            <IonItem lines="none" className="ion-justify-content-end">
              <IonButton
                type="button"
                fill="clear"
                onClick={onDidDismiss}
                disabled={loading}
              >
                Cancel
              </IonButton>
              <IonButton type="submit" disabled={loading}>
                {loading ? <IonSpinner name="crescent" /> : 'Login'}
              </IonButton>
            </IonItem>
          </IonList>
          <IonText>
            Need an account?{' '}
            <a href="https://latenightrecordpool.com/register">Register here</a>
            .
          </IonText>
        </form>
      </IonContent>
    </IonModal>
  );
};

export default LnrpLoginModal;
